export default __webpack_public_path__ + "static/media/movies_and_shows.4bda8017.jpeg";